module.exports = __webpack_public_path__ + "static/img/tabela.046a761.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/mate/tabela.png
// module id = Eymx
// module chunks = 0